import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { VentaService } from '../../../services/venta.service';
import { Venta } from './../../../models/venta';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import * as numeral from 'numeral';
import { Pagination } from '../../../models/pagination';
import { SessionService } from '../../../services/session.service';

@Component({
  selector: 'venta-list-modal',
  templateUrl: './venta-list-modal.component.html',
  styleUrls: ['./venta-list-modal.component.css'],
  providers: [ VentaService ]
})
export class VentaListModalComponent implements OnInit {
	@Output() onSelectedRow = new EventEmitter();
	@Input() qs = "";
	@Input() numero_decimales: number = 2;
	public ventas: Array<Venta> = [];
	public selectedRow: Number;
	public venta: Venta;
	public pagination: Pagination;
	public loading = false;
	public format_decimal: String;
	public Mod_FactElec: string;
	constructor(
		public VentaService: VentaService,
		public bsModalRef: BsModalRef,
		public ss: SessionService,
	) {
		this.ventas = [];
		this.venta = new Venta();
		this.pagination = new Pagination();
		this.format_decimal = "0,0.00";
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
    }

	ngOnInit() {
		let digitos = "";
		for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
		this.format_decimal = "0,0." + digitos;

		this.getVentas();
	}

	getVentasBySearch(text){
		let qs = "&q[serie]=" + text + "&q[punto_emision]=" + text + "&q[secuencial]=" + text + "&q[total]=" + text;
		this.pagination.current_page = 1;
		this.getVentas(qs);
	}

	getVentas(qs = ""){
		this.loading = true;
		// let tipo_comprobante_id = "";
		// if(this.Mod_FactElec){
        //     tipo_comprobante_id = "4,2";
        // }
        // else{
        //     tipo_comprobante_id = "1,2";
        // }
		this.VentaService.getAll("?page="+this.pagination.current_page + "&per_page=10&embed=tipocomprobante,notacredito,bodega,cliente?embed=tipoidentificacion,guiaremision,retencion,detalle?embed=producto&sort=-fecha_emision,-secuencial&status=A" + this.qs + qs).subscribe(
			res => {
				this.loading = false;
				this.ventas = res.data;
				this.pagination.current_page = res.current_page;
				this.pagination.from = res.from;
				this.pagination.to = res.to;
				this.pagination.total = res.total;
				this.pagination.last_page = res.last_page;
				this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
				this.pagination.prev_disabled = this.pagination.current_page === 1;
			},
			err => {
				this.loading = false;
				this.ventas = [];
			}
		);
	}

	numeroFactura(venta){
        return venta.serie + "-" + venta.punto_emision + "-" + venta.secuencial;
	}
	
	parseTipo(tipo){
		if( tipo === "CR" ){
			return "Crédito";
		}else{
			return "Contado";
		}
	}

	onSelectRow(venta, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de usuario
		this.venta = venta;
	}

	onDBLClick(usuario,i){
		this.onSelectRow(usuario,i);
		this.onSubmit();
	}

	onSubmit() {
		//envía de objecto usuario
		this.onSelectedRow.emit(this.venta);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}

	next(){
		this.pagination.current_page++;
		this.getVentas();
	}

	prev(){
		this.pagination.current_page--;
		this.getVentas();
	}

	first(){
		this.pagination.current_page = 1;
		this.getVentas();
	}

	last(){
		this.pagination.current_page = this.pagination.last_page;
		this.getVentas();
	}

	get formatDecimal(){
        return this.format_decimal;
    }
}




// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/venta-list-modal/venta-list-modal.component.ts